import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import style from "../css/Questions.module.css";
import { ErrorHandling } from "../../../State";
import {
  offerEvent,
  getQuizCategoriesQuestions,
  submitQuestions,
} from "../../../utils/api";
import UAParser from "ua-parser-js";
import FanduEarnBanner from "./FanduEarnBanner";

import banner1 from "../../../icons/banner1.png";
import banner2 from "../../../icons/banner2.png";
import banner3 from "../../../icons/banner3.png";
import banner4 from "../../../icons/banner4.png";
import banner5 from "../../../icons/banner5.png";
import fp from "../../../icons/coin.svg";

import Header from "./Header";

function QuizQuestionPage() {
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const { quizTitle } = useParams();

  const questionBanners = [banner1, banner2, banner3, banner4, banner5];
  let mId = localStorage.getItem("mId") || "2026";
  let uuid = localStorage.getItem("uuid");
  let ipAddress = localStorage.getItem("ip_address");
  let session_id = localStorage.getItem("session_id");

  const fanduUserId = localStorage.getItem("fanduUserId") || "";
  const phoneNumber = localStorage.getItem("phone");

  const [questions, setQuestions] = useState([]);
  const [category, setCategory] = useState("");
  const [quizId, setQuizId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);

  // Event data structure
  const offerRequestData = (eventMetaData) => {
    const parser = new UAParser();
    const result = parser.getResult();

    return {
      machine_id: mId,
      device_id: uuid,
      session_id: session_id,
      user_id: localStorage.getItem("userId") || "",
      ip_address: ipAddress,
      lat: "",
      lng: "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      deviceBrand: result.device.vendor || "Unknown",
      deviceModel: result.device.model || "Unknown",
      deviceType: result.device.type || "desktop",
      osName: result.os.name || "Unknown",
      osVersion: result.os.version || "Unknown",
      browserName: result.browser.name || "Unknown",
      browserVersion: result.browser.version || "Unknown",
      event_ts: Date.now().toString(),
      ...eventMetaData,
    };
  };

  const avail = (currentQuestionIndex, quiz_id, qs_id, EventName) => {
    if (!quiz_id || !qs_id) {
      console.warn("Missing quiz_id or qs_id", { quiz_id, qs_id });
      return;
    }

    const eventMetaData = {
      Event_Name: EventName,
      Event_Sub_Name: "Quiz_Categories",
      Event_Type: "Click",
      Event_Sub_Type: `Q${currentQuestionIndex + 1}`, // ✅ FIXED
      Event_MetaData: {
        quiz_id: quiz_id,
        qs_id: qs_id,
      },
    };

    const requestData = offerRequestData(eventMetaData);
    offerEvent(requestData);
  };

  const avail2 = (eventScreen, eventSubName, eventType, eventSubType) => {
    const eventMetaData = {
      Event_Name: eventScreen,
      Event_Sub_Name: eventSubName,
      Event_Type: eventType,
      Event_Sub_Type: eventSubType,
    };

    const requestData = offerRequestData(eventMetaData);
    offerEvent(requestData);
  };

  // FETCH QUESTIONS API
  const fetchQuizQuestions = async () => {
    try {
      setLoading(true);
      const response = await getQuizCategoriesQuestions(
        categoryId,
        fanduUserId,
      );

      if (response?.success) {
        setQuestions(response.data?.questions || []);
        setQuizId(response.data?.id || null);
        setCategory(response.data.Category.name);
      } else if (!response?.success) {
        ErrorHandling("Unable to load questions. Try again later. ");
      } else {
        setQuestions([]);
      }
    } catch (error) {
      console.log(error);
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  };

  // FETCH ON CATEGORY CHANGE
  useEffect(() => {
    if (categoryId) {
      fetchQuizQuestions();
    }
    avail2(
      `Quiz_Categories_Landing_Page_${categoryId}`,
      "Screen_Impressions",
      "Page_Open",
      "Questions",
    );
  }, [categoryId]);

  const quizCategory = JSON.parse(localStorage.getItem("selectedQuizCategory"));
  const selectedQuizTitle = quizCategory ? quizCategory.title : quizTitle;

  // RESET SELECTED OPTION
  useEffect(() => {
    setSelectedOption(null);
  }, [currentQuestionIndex]);

  const currentQuestion = questions[currentQuestionIndex];

  const currentBanner =
    questionBanners[currentQuestionIndex] || questionBanners[0];

  // OPTION CLICK
  const handleOptionClick = (optionIndex) => {
    const selectedOptionId = currentQuestion.question_options[optionIndex].id;
    avail(currentQuestionIndex, quizId, currentQuestion.id, selectedQuizTitle);

    const answerData = {
      question_id: currentQuestion.id,
      selected_option_id: selectedOptionId,
      correct_option_id: currentQuestion.correct_option_id,
    };

    const updatedAnswers = [...userAnswers];

    const existingIndex = updatedAnswers.findIndex(
      (ans) => ans.question_id === currentQuestion.id,
    );

    if (existingIndex !== -1) {
      updatedAnswers[existingIndex] = answerData;
    } else {
      updatedAnswers.push(answerData);
    }

    setUserAnswers(updatedAnswers);
    setSelectedOption(optionIndex);

    setTimeout(async () => {
      if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex((prev) => prev + 1);
      } else {
        // Last question answered
        const finalPayload = {
          quiz_id: quizId,
          responses: updatedAnswers,
        };

        localStorage.setItem("selectedAnswers", JSON.stringify(finalPayload));
        localStorage.setItem("quizId", quizId);

        if (fanduUserId) {
          // Auto submit
          submitQuestion();
        } else {
          // First-time user
          navigate("/login");
        }
      }
    }, 700);
  };

  const submitQuestion = async () => {
    const selectedAnswers = JSON.parse(localStorage.getItem("selectedAnswers"));
    if (!selectedAnswers) {
      return ErrorHandling("No selected answers found in local storage");
    }

    if (!fanduUserId || !phoneNumber) {
      navigate("/login");
      return;
    }
    try {
      setLoading(true);
      // debugger;
      const responses = selectedAnswers.responses;
      const quiz_id = selectedAnswers.quiz_id;
      const mobile = localStorage.getItem("phone");
      const finalPayload = {
        quiz_id,
        responses,
        mobile,
      };

      const response = await submitQuestions(finalPayload);

      if (response.success) {
        const data = response.data;
        const correct = data.filter((item) => item.is_correct).length;
        localStorage.setItem("userFanduPoints", response.total_score);
        localStorage.setItem("correctAnswers", correct);

        navigate("/thanku");
      } else if (response.success == "false") {
        ErrorHandling(response.message || "");
      } else {
        ErrorHandling(response.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Submit error:", error);
      ErrorHandling("Failed to submit your response");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={style.loaderWrapper}>
        <div className={style.loader}></div>
      </div>
    );
  }

  if (!questions.length || !currentQuestion) {
    return (
      <div className={style.loaderWrapper}>
        <p>No questions available.</p>
      </div>
    );
  }

  const fanduPoints = localStorage.getItem("userFanduPoints") || "0";

  return (
    <>
      <Header fanduPoints={fanduPoints} />

      <div className={style.quizPage}>
        <div className={style.quizWrapper}>
          {/* Progress */}
          <div className={style.progressRow}>
            <span className={style.progressText}>
              {currentQuestionIndex + 1}/{questions.length}
            </span>

            <div className={style.progressTrack}>
              <div
                className={style.progressFill}
                style={{
                  width: `${(currentQuestionIndex / questions.length) * 100}%`,
                }}
              />
            </div>
          </div>

          {/* Banner */}
          <div className={style.bannerWrap}>
            <img
              src={currentBanner}
              alt={`Question ${currentQuestionIndex + 1}`}
              className={style.quizBanner}
            />
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                color: "#3550DC",
                fontSize: "16px",
                fontWeight: "800",
                marginBottom: "5px",
              }}
            >
              {category}
            </div>
            <div style={{ marginTop: "-6px" }}>
              <FanduEarnBanner
                topText="Play &"
                bottomText="Earn"
                number={5}
                background="#3550DC"
                topTextColor="#FFFFFF"
                borderColor="#FAD140"
                bottomTextColor="#FAD140"
              />
            </div>
          </div>
          {/* Question */}
          <h2 className={style.questionText}>
            {currentQuestionIndex + 1}. {currentQuestion.question_text}
          </h2>

          <div className={style.pointsContainer}>
            <img src={fp} style={{ width: "18px" }} />
            <div>
              <b>1 point</b> for this question.
            </div>
          </div>

          {/* Options */}
          <div className={style.optionsList}>
            {currentQuestion.question_options.map((option, index) => (
              <div key={option.id}>
                <div
                  className={style.optionRow}
                  onClick={() => handleOptionClick(index)}
                >
                  <div className={style.radioOuter}>
                    {selectedOption === index && (
                      <div className={style.radioInner} />
                    )}
                  </div>

                  <span className={style.optionLabel}>
                    {option.option_text}
                  </span>
                </div>

                <div className={style.optionDivider} />
              </div>
            ))}
          </div>

          {/* {currentQuestionIndex === questions.length - 1 && (
            <button
              className={style.claimBtn}
              onClick={submitQuestion}
              disabled={selectedOption === null}
            >
              Submit
            </button>
          )} */}
        </div>
      </div>
    </>
  );
}

export default QuizQuestionPage;
